import React from 'react';
import { Field, ErrorMessage } from 'formik';
import TextError from './TextError';
import DatePicker from 'react-datepicker';
import moment from 'moment'
import "react-datepicker/dist/react-datepicker.css";
const Dates = (props) => {
    const {label, name, showTime=false,onChange,minDate=null,required=false,...rest} = props
    // const years = range(1990, getYear(new Date()) + 1, 1);
    const years = []
    for(let i = 1970;i<=new Date().getFullYear()+100;i++){
        years.push(i)
    }
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return (
        <div className='form'>
            <div className='form__content'>
            <label className='form__content--label' htmlFor={name}>{label}{required==true && <span style={{color:"red"}}>&nbsp;*</span>}</label>
            <Field
                name={name}
            >
                {
                    ({form, field}) => {
                        const {setFieldValue} = form;
                        const {value} = field

                        return (
                            <DatePicker 
                            renderCustomHeader={({
                                date,
                                changeYear,
                                changeMonth,
                                decreaseMonth,
                                increaseMonth,
                                prevMonthButtonDisabled,
                                nextMonthButtonDisabled,
                              }) => (
                                <div 
                                  style={{
                                    margin: 10,
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span style={{paddingRight:"8px"}}  onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                  <i className="fa-solid fa-chevron-left"></i>
                                  </span>
                                  <select
                                    value={new Date(date).getFullYear()}
                                    onChange={({ target: { value } }) => changeYear(value)}
                                  >
                                    {years.map((option) => (
                                      <option key={option} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                        
                                  <select
                                    value={months[new Date(date).getMonth()]}
                                    onChange={({ target: { value } }) =>
                                      changeMonth(months.indexOf(value))
                                    }
                                  >
                                    {months.map((option) => (
                                      <option key={option} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                        
                                  <span style={{paddingLeft:"8px"}} onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                  <i className="fa-solid fa-chevron-right"></i>
                                  </span>
                                </div>
                              )}
                                id={name}
                                {...field}
                                {...rest}
                                selected={value !== null && value !== undefined && value.length !==0 && new Date(value)}
                                onChange={val => setFieldValue(name, val)}
                                 dayAriaLabel="Day"
                                //  required
                                //  showTimeSelect
                                placeholderText={minDate !== null &&minDate !== undefined && minDate.length===0?"enter start date":"YYYY/MM/DD"}
                                dateFormat="yyyy/MM/dd"
                                className='form__content--input'
                                minDate={minDate?new Date(minDate):undefined}
                            
                                disabled={minDate !== null &&minDate !== undefined && minDate.length===0}
                                maxDate={new Date()}
                            />
                        )
                    }
                }
            </Field>
            </div>
            <ErrorMessage name={name} component={TextError} />
        </div>
    )
}

export default Dates
